/** Backend API base — from root `.env` → `VITE_API_URL` (see accessnowcare). */
export const getApiUrl = (): string => {
  const url = import.meta.env.VITE_API_URL || __API_URL__ || "/api";
  return String(url).replace(/\/$/, "");
};
